import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { Store } from '@ngrx/store';

import { selectSelectedChannel, selectUser } from '../../../../store/app.selectors';
import { setLoadingChannel } from '../../../shared/store/ui.actions';
import { IUserProfile } from '../../../user/interfaces/IUserProfile';
import { joinChannel, unsetMessages } from '../../store/chat.actions';
import { AppStateWithChat } from '../../store/chat.reducer';

@Component({
  selector: 'ngx-join-channel',
  templateUrl: './join-channel.component.html',
  styleUrls: ['./join-channel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class JoinChannelComponent {
  private store = inject(Store<AppStateWithChat>);

  selectedChannel = toSignal(this.store.select(selectSelectedChannel), { initialValue: null });
  user = toSignal(this.store.select(selectUser), { initialValue: null as IUserProfile | null });
  isLoading = signal(false);

  joinChannel(): void {
    const channel = this.selectedChannel();
    if (!channel) {
      return;
    }
    this.isLoading.set(true);
    this.store.dispatch(unsetMessages());
    this.store.dispatch(setLoadingChannel({ value: true }));
    this.store.dispatch(joinChannel({ channelUID: channel.uid }));
  }
}
